<template>
  <div class="video-tutorials no-step">
    <h4 class="guide-header">Watching the right tutorial video</h4>
    <div class="guide-content">
      <div class="row mb-4" v-for="(video, index) in videos" :key="index">
        <div class="col">
          <h4>{{ video.title }}</h4>
          <div class="embed-responsive embed-responsive-16by9">
            <iframe
              class="embed-responsive-item"
              :src="'https://www.youtube.com/embed/' + video.video + '?rel=0'"
              allowfullscreen
              :title="video.title"
            ></iframe>
          </div>
        </div>
      </div>
    </div>
    <div class="btns-container row">
      <div class="col">
        <div class="btn btn-outline-secondary" @click="prev">Previous</div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "VideoTutorialsSelection",
  data() {
    return {
      videos: [
        { video: "HdWNcNkAtVs", title: "Compose a LED lighting system" },
        {
          video: "ITxIAgeVwLI",
          title: "Find a matching driver for your LED module",
        },
        { video: "C-i2Qt9knt0", title: "How to find a product or family" },
        {
          video: "irMcbOswGVk",
          title: "Create a Tunable White system with sensor",
        },
        {
          video: "iP7Jeh3bo1E",
          title: "Add emergency Lighting components to your system",
        },
        {
          video: "Ss7k9-bK-qY",
          title: "How to combine linear modules of different lengths",
        },
      ],
    };
  },
  methods: {
    prev() {
      this.$emit("prev", "howCanIHelp");
    },
  },
};
</script>
